import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeploymentStack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import StackStateBadge from "components/StackStateBadge";

const TemplateDeploymentStacksStateCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeploymentStack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <StackStateBadge state={stack.state} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentStacksStateCell;
